module.exports = __webpack_public_path__ + "static/media/feat3.0abf74b4.svg";